import { render, staticRenderFns } from "./NewEventView.vue?vue&type=template&id=7052987f"
import script from "./NewEventView.vue?vue&type=script&lang=js"
export * from "./NewEventView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports